import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

// Components
import { TextLoader } from '~/components/Loaders'
import {
	Bookmarks,
	EditProfile,
	MiniBio as MiniBioField,
	Name as NameField,
	ProfileImage,
	Social as SocialFields,
	Website as WebsiteField
} from './components'
import About from '../Body/components/About'

export default class extends React.Component {
    static propTypes = {
		profile: PropTypes.object.isRequired,
		user: PropTypes.object.isRequired,
		session: PropTypes.object.isRequired,
		changed_fields: PropTypes.object.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		isSessionUser: PropTypes.bool.isRequired,
		addUpdateField: PropTypes.func.isRequired,
		removeUpdateField: PropTypes.func.isRequired,
	};

    updateName = (e) => {
		var names = e.target.value.split(" "),
			first_name = names.shift(),
			other_names = names.join(" ")
		this.props.addUpdateField('core', 'first_name', first_name)
		this.props.addUpdateField('core', 'last_name', other_names)
		this.props.addUpdateField('core', 'display_name', first_name + ' ' + other_names)
	};

    updateWebsite = (val) => {
		console.log(val)
		this.props.addUpdateField('core', 'user_url', val)
	};

    updateField = (field, val) => {
		this.props.addUpdateField('custom', field, val)
	};

    render() {

		let { bookmarks, fetching } = this.props.session,
			fetchingBookmarks = fetching.bookmarks,
			{ profile, user, editing_fields, isSessionUser } = this.props,
			userBookmarks = !!isSessionUser ? bookmarks : profile.bookmarks;
		
		return (

			<div className={'row panel content-row editable mbot20 full-height ' + (editing_fields ? 'editing' : '')} id="profileHeader">

            	<div className="col-sm-3 col-xs-4 ptop20 pbot20">

            		<ProfileImage 
            			profile_picture={user.profile_picture} 
            			editing_fields={editing_fields}
            			addUpdateField={this.props.addUpdateField}
            			removeUpdateField={this.props.removeUpdateField} />

            	</div>

				<div className="col-sm-5 col-xs-8 ptop30 pbot20 pleft0-xs ptop20-xs">

					<NameField user={user} editing_fields={editing_fields} updateName={this.updateName} />

					<MiniBioField user={user} editing_fields={editing_fields} updateField={this.updateField} isSessionUser={isSessionUser} />

					<WebsiteField user={user} editing_fields={editing_fields} updateWebsite={this.updateWebsite} isSessionUser={isSessionUser} />

					<SocialFields user={user} editing_fields={editing_fields} updateField={this.updateField} />

            	</div>

            	<div className="visible-xs clearfix border-bottom-light-gray"></div>

				<div className="col-sm-4 col-xs-12 ptop30 pbot20 border-left-light-gray border-left-none-xs">

                    { this.props.session.sessionsAllowed
                        ? <Bookmarks bookmarks={userBookmarks} fetching={fetchingBookmarks}/>
						: <About {...user} isSessionUser={false} editing_fields={false} addUpdateField={() => {}} />
                    }

				</div>

        	</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/index.jsx